module.exports = __webpack_public_path__ + "img/Sumpfkühe.ff27c2b6.jpg";